export const schemeOptions = [
    {value: "general", label: "Общее сопоставление"},
    {value: "old", label: "Модель (старая схема)"},
    {value: "new", label: "Модель (новая схема)"},
    {value: "year", label: "Модельный год"},
    {value: "engine", label: "Двигатель"},
];

export const schemeLabels = schemeOptions.reduce((acc, opt) => {
    acc[opt.value] = opt.label;
    return acc;
}, {});

export const schemeColors = {
    general: "default",
    old: "warning",
    new: "success",
    year: "info",
    engine: "error",
};
